var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{attrs:{"id":"profile"}},[(_vm.showUserTile)?_c('user-tile',{attrs:{"user":_vm.user}}):_vm._e(),_c('div',{attrs:{"id":"gallery-wrapper"}},[_c('gallery',{attrs:{"type":"profile","id":_vm.user.id}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }